<template>
  <div id="main-wrapper">
    <AdminNavbar />

    <div class="page-title">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <h2 class="ipt-title">{{ t('Welcome!') }}</h2>
          </div>
        </div>
      </div>
    </div>

    <section class="bg-light">
      <div class="container-fluid">
        <div class="row">
            <div class="col-lg-3 col-md-12">
                <AdminSidebar :open="show" @update:open="show = $event" :user="user"/>
            </div>

            <div class="col-lg-9 col-md-12">
                <div class="dashboard-wraper w-100">
                <div class="form-submit">
                    <h4>{{ $t('Complete Your Profile') }}</h4>

                    <div class="submit-section">
                        <div class="row">

                        <div class="form-group col-md-6">
                            <label>{{ t("Phone") }}<span class="text-danger">*</span></label>
                            <input
                                ref="phoneInput"
                                type="tel"
                                class="form-control"
                                required
                            />

                            <small class="text-danger">
                                {{ errors.phone?.[0] }}
                            </small>
                        </div>

                        <div class="form-group col-md-6">
                            <label>{{ t("Company Name") }}<span class="text-danger">*</span></label>
                            <input
                            v-model="form.company_name"
                            type="text"
                            class="form-control"
                            required
                            />
                            <small class="text-danger">{{ errors.company_name?.[0] }}</small>
                        </div>

                        <div class="form-group col-md-6 mt-3">
                            <label>{{ t("Country") }}<span class="text-danger">*</span></label>

                            <select
                            v-model="selectedCountry"
                            class="form-control"
                            required
                            >
                            <option :value="null">
                                {{ t("Select Country") }}
                            </option>

                            <option
                                v-for="country in countries"
                                :key="country.value"
                                :value="country.value"
                            >
                                {{ country.label }}
                            </option>

                            </select>

                            <small class="text-danger">{{ errors.country_id?.[0] }}</small>
                        </div>

                        <div class="form-group col-md-6 mt-3">
                            <label>{{ t("City") }}<span class="text-danger">*</span></label>

                            <select
                            v-model="form.city_id"
                            class="form-control"
                            required
                            >

                            <option :value="null">
                                {{ t("Select City") }}
                            </option>

                            <option
                                v-for="city in cities"
                                :key="city.id"
                                :value="city.id"
                            >
                                {{ city.name }}
                            </option>

                            </select>

                            <small class="text-danger">{{ errors.city_id?.[0] }}</small>

                        </div>

                        <div class="form-group col-md-6">
                            <label>{{ t("Job Title") }}</label>
                            <input
                            v-model="form.job"
                            type="text"
                            class="form-control"
                            />
                            <small class="text-danger">{{ errors.job?.[0] }}</small>
                        </div>

                        <div class="col-12 mt-4">
                            <button
                            class="btn btn-primary"
                            @click.prevent="submit"
                            >
                            {{ t("Save") }}
                            </button>
                        </div>

                        </div>                        
                    </div>
                </div>
                </div>
            </div>
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount } from 'vue';

import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";

import axios from 'axios';
import { useToast } from 'vue-toastification';
import { useI18n } from "vue-i18n";
import AdminNavbar from '@/components/navbar/admin-navbar.vue'
import FooterTop from '@/components/footer/footer-top.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import AdminSidebar from '@/components/admin-sidebar.vue'



const toast = useToast();
const { t,locale } = useI18n();
const cities = ref([]);
const countries = ref([]);
const selectedCountry = ref(null);
const phoneInput = ref(null);
const phoneValid = ref(false);
let iti = null;

const form = ref({
    phone: "",
    company_name: "",
    job: "",
    country_id: null,
    city_id: null,
});

const errors = ref({});

const fetchCountries = async () => {
  try {
    const response = await axios.get("/countries/All", {
      params: { lang: locale.value }
    });

    if (response.data && Array.isArray(response.data.data)) {
      countries.value = response.data.data
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map(country => ({
          label: country.name,
          value: country.id
        }));
    }
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const fetchCities = async () => {
    if (!selectedCountry.value) {
        cities.value = [];
        form.value.city_id = null;
        return;
    }
    try {
        const response = await axios.get(`/countries/${selectedCountry.value}`,
            {
                params:{
                    lang: locale.value
                }
            }
        );
        cities.value = response.data.data.cities;
        form.value.country_id = selectedCountry.value;
    } catch (error) {
        console.error(error);
    }
};

const submit = async () => {

    errors.value = {};

    if (!iti.isValidNumber()) {

        errors.value.phone = [
            t("Invalid phone number")
        ];

        return;

    }

    form.value.phone = iti.getNumber();
    const token = localStorage.getItem('auth_token');
    try {

        await axios.post("/visitor/complete-profile",form.value,{
            headers: { Authorization: `Bearer ${token}` }
        });

        toast.success(t("Profile updated successfully."));
        errors.value = {};
    } catch (error) {
        if (error.response?.status === 422) {
            errors.value = error.response.data.errors;
            return;
        }
        toast.error(error.response?.data?.message ??t("Something went wrong."));

    }

};

onMounted(async () => {
    fetchCountries();

    iti = intlTelInput(phoneInput.value, {
        initialCountry: "sy",
        separateDialCode: true,
        strictMode: true,

        loadUtils: () =>
        import("intl-tel-input/build/js/utils.js")

    });

    await new Promise(resolve => setTimeout(resolve, 300));

    phoneInput.value.addEventListener("input", updatePhone);
    phoneInput.value.addEventListener("countrychange", updatePhone);

    updatePhone();
});
onBeforeUnmount(() => {
    if (phoneInput.value) {
        phoneInput.value.removeEventListener("input", updatePhone);
        phoneInput.value.removeEventListener("countrychange", updatePhone);
    }

    if (iti) {
        iti.destroy();
    }
});

function updatePhone() {
    if (!iti) return;

    phoneValid.value = iti.isValidNumber();

    try {
        form.value.phone = iti.getNumber(); 
    } catch {
        form.value.phone = phoneInput.value.value;
    }
}

watch(locale, () => {
  fetchCountries();
  if (selectedCountry.value) fetchCities();
});

watch(selectedCountry, () => {
  fetchCities();
});

</script>
<style>
.iti {
    width: 100%;
}

.iti input {
    width: 100%;
}
.iti__flag {
    background-image: url("~@/assets/img/flags.webp");
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 192dpi) {
    .iti__flag {
        background-image: url("~@/assets/img/flags@2x.webp");
    }
}
</style>